// extracted by mini-css-extract-plugin
export default {"container":"document_form_date_container__-3OCW","input":"document_form_date_input__Tc+AY","tooltip":"document_form_date_tooltip__--lhM"};